import { call, put, select } from 'redux-saga/effects';
import { Api } from '../../api/api';
import { downloadFile, errorMessage } from '../../utils';
import { actions } from '../actions';
import {
  getExportQueueStorageKey,
  normalizeExport,
  normalizeExports,
} from './download.helpers';

export function* getExportsSaga() {
  try {
    yield put(actions.download.setExportsLoadingAction(true));

    const response = yield call(Api.getExports);
    const exports = normalizeExports(response.exports || response);

    yield put(actions.download.setExportsAction(exports));
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.download.setExportsLoadingAction(false));
  }
}

export function* downloadExportedFileSaga({ filename, url }) {
  try {
    const options = {
      method: 'GET',
      encoding: null,
      url,
    };

    const response = yield call(Api.withAuth, options);

    yield put(actions.download.setDownloadedFile(response));

    if (filename) {
      downloadFile(response, filename);
    }
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  }
}

export function* cancelExportSaga({ id }) {
  try {
    const response = yield call(Api.cancelExport, id);
    const exportItem = normalizeExport(response);

    if (exportItem) {
      yield put(actions.download.upsertExportAction(exportItem));
    } else {
      yield put(
        actions.download.upsertExportAction({
          id,
          status: 'canceled',
          finished_at: Date.now(),
          error: 'Canceled',
        })
      );
    }

    yield put(actions.download.getExportsAction());
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  }
}

export function* clearCompletedExportsSaga() {
  try {
    const exports = yield select(state => state.download.exports);
    const dismissedExportIds = yield select(
      state => state.download.dismissedExportIds
    );
    const adminId = yield select(state => state.auth.user?.id);

    const completedExportIds = exports
      .filter(item => item.status === 'completed')
      .map(item => item.id);

    const nextDismissedExportIds = Array.from(
      new Set([...dismissedExportIds, ...completedExportIds])
    );

    localStorage.setItem(
      getExportQueueStorageKey(adminId),
      JSON.stringify(nextDismissedExportIds)
    );

    yield put(
      actions.download.setDismissedExportIdsAction(nextDismissedExportIds)
    );
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  }
}
